import Login from '@/pages/security/Login'
import ResetPassword from '@/pages/security/ResetPassword'
import ForgotPassword from '@/pages/security/ForgotPassword'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuthentication: false }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuthentication: false },
    props: true
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/security.js